import { CategoryFiltersContainer, FilterButton } from './styled'
import { useRouter } from 'next/router'

const CategoryFilters = ({
  categories,
  setCategoryId,
  categoryId,
}: {
  categories?: ITagsAndCategories
  setCategoryId: (id: number | undefined) => void
  categoryId: number | undefined
}) => {
  const router = useRouter()
  if (!categories) {
    return null
  }

  const handleCategoryClick = (id: number | undefined) => {
    setCategoryId(id)

    const query = { ...router.query }

    if (id) {
      query.category = String(id)
    } else {
      delete query.category
    }

    router.push(
      {
        pathname: router.pathname,
        query,
      },
      undefined,
      { shallow: true },
    )
  }

  return (
    <CategoryFiltersContainer>
      <FilterButton
        onClick={() => handleCategoryClick(undefined)}
        categoryId={undefined}
        activeCategory={categoryId}
      >
        All
      </FilterButton>
      {categories.categories.map((category) => (
        <FilterButton
          key={category.id}
          onClick={() => handleCategoryClick(category.id)}
          categoryId={category.id}
          activeCategory={categoryId}
        >
          {category.title}
        </FilterButton>
      ))}
    </CategoryFiltersContainer>
  )
}

export default CategoryFilters
